module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "基本信息"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-orthodontics",
    staticStyle: {
      "margin-left": "3px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n        " + _vm._s(_vm.orderDetail.demContact) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-orthodontics"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n        " + _vm._s(_vm.orderDetail.demPhone) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-orthodontics"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n        " + _vm._s(_vm.orderDetail.demPatient) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-orthodontics"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n        " + _vm._s(_vm.orderDetail.demSex == '00' ? '男' : '女') + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-orthodontics"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n        " + _vm._s(_vm.orderDetail.orthodonticsData.patientAge) + "\n      ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    staticClass: "makeCondition",
    attrs: {
      "label": "矫治需求"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "case-class"
  }, [_c('div', {
    staticClass: "case-class-box",
    staticStyle: {
      "line-height": "50px",
      "font-size": "15px",
      "width": "50%",
      "margin-left": "1.3%"
    }
  }, [_c('p', {
    staticClass: "case-class-item",
    staticStyle: {
      "float": "left"
    }
  }, [_c('span', [_vm._v("矫治牙列")]), _vm._v(" "), _c('el-checkbox-group', {
    staticClass: "molar-item-check",
    staticStyle: {
      "line-height": "50px",
      "width": "430px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderDetail.orthodonticsData.countCalList),
      callback: function($$v) {
        _vm.$set(_vm.orderDetail.orthodonticsData, "countCalList", $$v)
      },
      expression: "orderDetail.orthodonticsData.countCalList"
    }
  }, [_c('el-checkbox', {
    staticStyle: {
      "margin-right": "13.5%"
    },
    attrs: {
      "label": "00"
    }
  }, [_vm._v("上颌5-5")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-right": "13.5%"
    },
    attrs: {
      "label": "01"
    }
  }, [_vm._v("下颌5-5")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-right": "13.5%"
    },
    attrs: {
      "label": "02"
    }
  }, [_vm._v("上下颌5-5")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "input-rush",
    staticStyle: {
      "margin": "0 4.5% 0 1%"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n          " + _vm._s(_vm.parseMoney(_vm.orderDetail.orderRushFee)) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-cal"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n          " + _vm._s(_vm.parseMoney(_vm.orderDetail.orderAmount)) + " 元\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "canvasImg"
  }, [(_vm.orthodonticsData.correctiveImages != null) ? _c('img', {
    attrs: {
      "src": _vm.orthodonticsData.correctiveImages.join(',')
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "其他要求"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-textarea",
    staticStyle: {
      "width": "95%"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入备注信息",
      "readonly": ""
    },
    model: {
      value: (_vm.orderDetail.orderRemark),
      callback: function($$v) {
        _vm.$set(_vm.orderDetail, "orderRemark", $$v)
      },
      expression: "orderDetail.orderRemark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "临床检查信息与要求（非必填项）"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dental-relationship"
  }, [_c('div', {
    staticClass: "molar-tooth"
  }, [_c('div', {
    staticClass: "molar-Str"
  }, [_vm._v("\n            磨牙关系\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "molar-select"
  }, [_c('p', {
    staticClass: "molar-select-item"
  }, [_c('span', {
    staticClass: "direction"
  }, [_vm._v("右侧")]), _vm._v(" "), _c('el-checkbox-group', {
    staticClass: "molar-item-check",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orthodonticsData.molarRelationShipRight),
      callback: function($$v) {
        _vm.$set(_vm.orthodonticsData, "molarRelationShipRight", $$v)
      },
      expression: "orthodonticsData.molarRelationShipRight"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "01"
    }
  }, [_vm._v("I类")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "02"
    }
  }, [_vm._v("II类")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "03"
    }
  }, [_vm._v("III类")])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "molar-select-item"
  }, [_c('span', {
    staticClass: "direction"
  }, [_vm._v("左侧")]), _vm._v(" "), _c('el-checkbox-group', {
    staticClass: "molar-item-check",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orthodonticsData.molarRelationShipLeft),
      callback: function($$v) {
        _vm.$set(_vm.orthodonticsData, "molarRelationShipLeft", $$v)
      },
      expression: "orthodonticsData.molarRelationShipLeft"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "01"
    }
  }, [_vm._v("I类")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "02"
    }
  }, [_vm._v("II类")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "03"
    }
  }, [_vm._v("III类")])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "molar-tooth"
  }, [_c('div', {
    staticClass: "molar-Str"
  }, [_vm._v("尖牙关系")]), _vm._v(" "), _c('div', {
    staticClass: "molar-select"
  }, [_c('p', {
    staticClass: "molar-select-item"
  }, [_c('span', {
    staticClass: "direction"
  }, [_vm._v("右侧")]), _vm._v(" "), _c('el-checkbox-group', {
    staticClass: "molar-item-check",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orthodonticsData.canineRelationShipRight),
      callback: function($$v) {
        _vm.$set(_vm.orthodonticsData, "canineRelationShipRight", $$v)
      },
      expression: "orthodonticsData.canineRelationShipRight"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "01"
    }
  }, [_vm._v("中性")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "02"
    }
  }, [_vm._v("远中")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "03"
    }
  }, [_vm._v("近中")])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "molar-select-item"
  }, [_c('span', {
    staticClass: "direction"
  }, [_vm._v("左侧")]), _vm._v(" "), _c('el-checkbox-group', {
    staticClass: "molar-item-check",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orthodonticsData.canineRelationShipLeft),
      callback: function($$v) {
        _vm.$set(_vm.orthodonticsData, "canineRelationShipLeft", $$v)
      },
      expression: "orthodonticsData.canineRelationShipLeft"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "01"
    }
  }, [_vm._v("中性")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "02"
    }
  }, [_vm._v("远中")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "03"
    }
  }, [_vm._v("近中")])], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "case-class"
  }, [_c('div', {
    staticClass: "case-class-box",
    staticStyle: {
      "margin": "2% 0 0 2.5%",
      "line-height": "40px",
      "font-size": "15px"
    }
  }, [_c('p', {
    staticClass: "case-class-item",
    staticStyle: {
      "float": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "width": "65px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("病例分类")]), _vm._v(" "), _c('el-checkbox-group', {
    staticClass: "molar-item-check",
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orthodonticsData.caseClass),
      callback: function($$v) {
        _vm.$set(_vm.orthodonticsData, "caseClass", $$v)
      },
      expression: "orthodonticsData.caseClass"
    }
  }, _vm._l((_vm.caseList), function(val, key) {
    return _c('el-checkbox', {
      key: key,
      staticClass: "item-check",
      staticStyle: {
        "margin-right": "15px"
      },
      attrs: {
        "label": val.index
      }
    }, [_vm._v(_vm._s(val.label))])
  }), 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "order-detail-upload",
    staticStyle: {
      "min-height": "calc(100vh - 713px)",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('span', {
    staticClass: "title-Str"
  }, [_vm._v("牙列间隙")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "00",
      "disabled": ""
    },
    model: {
      value: (_vm.orthodonticsData.interdentalSpace),
      callback: function($$v) {
        _vm.$set(_vm.orthodonticsData, "interdentalSpace", $$v)
      },
      expression: "orthodonticsData.interdentalSpace"
    }
  }, [_vm._v("全部关闭")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "01",
      "disabled": ""
    },
    model: {
      value: (_vm.orthodonticsData.interdentalSpace),
      callback: function($$v) {
        _vm.$set(_vm.orthodonticsData, "interdentalSpace", $$v)
      },
      expression: "orthodonticsData.interdentalSpace"
    }
  }, [_vm._v("保留间隙")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orthodonticsData.interdentalSpaceRemark),
      expression: "orthodonticsData.interdentalSpaceRemark"
    }],
    staticClass: "input-join",
    attrs: {
      "placeholder": "输入说明",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.orthodonticsData.interdentalSpaceRemark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orthodonticsData, "interdentalSpaceRemark", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title-Str",
    staticStyle: {
      "margin-left": "-50px"
    }
  }, [_vm._v("后牙反𬌗")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "00",
      "disabled": ""
    },
    model: {
      value: (_vm.orthodonticsData.toothRetroversion),
      callback: function($$v) {
        _vm.$set(_vm.orthodonticsData, "toothRetroversion", $$v)
      },
      expression: "orthodonticsData.toothRetroversion"
    }
  }, [_vm._v("保持")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "01",
      "disabled": ""
    },
    model: {
      value: (_vm.orthodonticsData.toothRetroversion),
      callback: function($$v) {
        _vm.$set(_vm.orthodonticsData, "toothRetroversion", $$v)
      },
      expression: "orthodonticsData.toothRetroversion"
    }
  }, [_vm._v("纠正")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dental-jaw",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticClass: "jaw-Str"
  }, [_vm._v("中线")]), _vm._v(" "), _c('div', {
    staticClass: "dental-jaw"
  }, [_c('div', {
    staticStyle: {
      "line-height": "30px",
      "margin-left": "6px",
      "width": "62%"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "25px"
    }
  }, [_vm._v("上颌")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin": "0 20px 0 22px"
    },
    attrs: {
      "label": "00",
      "disabled": ""
    },
    model: {
      value: (_vm.orthodonticsData.centerUpper),
      callback: function($$v) {
        _vm.$set(_vm.orthodonticsData, "centerUpper", $$v)
      },
      expression: "orthodonticsData.centerUpper"
    }
  }, [_vm._v("保持")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "01",
      "disabled": ""
    },
    model: {
      value: (_vm.orthodonticsData.centerUpper),
      callback: function($$v) {
        _vm.$set(_vm.orthodonticsData, "centerUpper", $$v)
      },
      expression: "orthodonticsData.centerUpper"
    }
  }, [_vm._v("改善")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_vm._v("近中(+)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderDetail.orthodonticsData.centerUpperNearMid),
      expression: "orderDetail.orthodonticsData.centerUpperNearMid"
    }],
    staticStyle: {
      "border-bottom": "1px solid black",
      "background": "#F7F7F7",
      "width": "75px",
      "text-align": "center"
    },
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.orderDetail.orthodonticsData.centerUpperNearMid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderDetail.orthodonticsData, "centerUpperNearMid", $event.target.value)
      }
    }
  }), _vm._v("mm\n              "), _c('span', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v("远中(-)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderDetail.orthodonticsData.centerUpperFarAway),
      expression: "orderDetail.orthodonticsData.centerUpperFarAway"
    }],
    staticStyle: {
      "border-bottom": "1px solid black",
      "background": "#F7F7F7",
      "width": "75px",
      "text-align": "center"
    },
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.orderDetail.orthodonticsData.centerUpperFarAway)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderDetail.orthodonticsData, "centerUpperFarAway", $event.target.value)
      }
    }
  }), _vm._v("mm\n            ")], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "25px"
    }
  }, [_vm._v("下颌")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin": "0 20px 0 22px"
    },
    attrs: {
      "label": "00",
      "disabled": ""
    },
    model: {
      value: (_vm.orthodonticsData.centerDown),
      callback: function($$v) {
        _vm.$set(_vm.orthodonticsData, "centerDown", $$v)
      },
      expression: "orthodonticsData.centerDown"
    }
  }, [_vm._v("保持")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "01",
      "disabled": ""
    },
    model: {
      value: (_vm.orthodonticsData.centerDown),
      callback: function($$v) {
        _vm.$set(_vm.orthodonticsData, "centerDown", $$v)
      },
      expression: "orthodonticsData.centerDown"
    }
  }, [_vm._v("改善")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_vm._v("近中(+)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderDetail.orthodonticsData.centerDownNearMid),
      expression: "orderDetail.orthodonticsData.centerDownNearMid"
    }],
    staticStyle: {
      "border-bottom": "1px solid black",
      "background": "#F7F7F7",
      "width": "75px",
      "text-align": "center"
    },
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.orderDetail.orthodonticsData.centerDownNearMid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderDetail.orthodonticsData, "centerDownNearMid", $event.target.value)
      }
    }
  }), _vm._v("mm\n              "), _c('span', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v("远中(-)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderDetail.orthodonticsData.centerDownFarAway),
      expression: "orderDetail.orthodonticsData.centerDownFarAway"
    }],
    staticStyle: {
      "border-bottom": "1px solid black",
      "background": "#F7F7F7",
      "width": "75px",
      "text-align": "center"
    },
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.orderDetail.orthodonticsData.centerDownFarAway)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderDetail.orthodonticsData, "centerDownFarAway", $event.target.value)
      }
    }
  }), _vm._v("mm\n            ")], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-21px",
      "line-height": "30px"
    }
  }, [_c('div', [_c('span', {
    staticClass: "title-Str"
  }, [_vm._v("覆𬌗")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "00",
      "disabled": ""
    },
    model: {
      value: (_vm.orthodonticsData.coverUp),
      callback: function($$v) {
        _vm.$set(_vm.orthodonticsData, "coverUp", $$v)
      },
      expression: "orthodonticsData.coverUp"
    }
  }, [_vm._v("保持")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "01",
      "disabled": ""
    },
    model: {
      value: (_vm.orthodonticsData.coverUp),
      callback: function($$v) {
        _vm.$set(_vm.orthodonticsData, "coverUp", $$v)
      },
      expression: "orthodonticsData.coverUp"
    }
  }, [_vm._v("改善")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderDetail.orthodonticsData.coverUpParam),
      expression: "orderDetail.orthodonticsData.coverUpParam"
    }],
    staticStyle: {
      "border-bottom": "1px solid black",
      "background": "#F7F7F7",
      "width": "75px",
      "text-align": "center"
    },
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.orderDetail.orthodonticsData.coverUpParam)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderDetail.orthodonticsData, "coverUpParam", $event.target.value)
      }
    }
  }), _vm._v("mm\n            ")], 1), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "title-Str"
  }, [_vm._v("覆盖")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "00",
      "disabled": ""
    },
    model: {
      value: (_vm.orthodonticsData.cover),
      callback: function($$v) {
        _vm.$set(_vm.orthodonticsData, "cover", $$v)
      },
      expression: "orthodonticsData.cover"
    }
  }, [_vm._v("保持")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "01",
      "disabled": ""
    },
    model: {
      value: (_vm.orthodonticsData.cover),
      callback: function($$v) {
        _vm.$set(_vm.orthodonticsData, "cover", $$v)
      },
      expression: "orthodonticsData.cover"
    }
  }, [_vm._v("改善")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderDetail.orthodonticsData.coverParam),
      expression: "orderDetail.orthodonticsData.coverParam"
    }],
    staticStyle: {
      "border-bottom": "1px solid black",
      "background": "#F7F7F7",
      "width": "75px",
      "text-align": "center"
    },
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.orderDetail.orthodonticsData.coverParam)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderDetail.orthodonticsData, "coverParam", $event.target.value)
      }
    }
  }), _vm._v("mm\n            ")], 1)])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("下单名称：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("联系方式：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("患者姓名：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("患者性别：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("患者年龄：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("加急费：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("总价：")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f3525d9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/orthodonticsOrder/orthodonticsOrderDetail.vue
// module id = 670
// module chunks = 0